export default __webpack_public_path__ + "static/media/Background_00174.c9d04cb1.png";